module.exports = __webpack_public_path__ + "static/rainberry-products-128e588f026f58e321fd7a57bfdc2fe1.svg";